require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
Array.prototype.chunkArray = function (chunk_size) {
  var index = 0;
  var arrayLength = this.length;
  var tempArray = [];
  for (index = 0; index < arrayLength; index += chunk_size) {
    myChunk = this.slice(index, index + chunk_size);
    tempArray.push(myChunk);
  }
  return tempArray;
};
Array.equal = function (a, b) {
  return a.every(function (x) {
    return b.includes(x);
  }) && b.every(function (x) {
    return a.includes(x);
  });
};